export default __webpack_public_path__ + "static/media/246.0ba4cc60.jpg";